
import { defineComponent, watch, ref, inject } from "vue"
import { useI18n } from "vue-i18n/index";
export default defineComponent({
    name: 'FDPeriodo',
    props: {
        periods: {
            type: Array,
            required: true,
            default: []
        }
    },
    setup(props) {
        const { t } = useI18n();
        const listPeriods = ref<any>([])
        const gblPeriodo = inject<any>('gblPeriodo')
        

        const setAnio = () => {
            if(props.periods.length > 0) {
                listPeriods.value = props.periods
                gblPeriodo.value = listPeriods.value[0]?.idanio
            }
        }

        watch(() => props.periods, setAnio);
        
        return {
            t,
            listPeriods, gblPeriodo, setAnio
        }
    }
   
})
